/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState   } from "react";
import { GoogleMap, Marker, LoadScript,InfoWindow } from "@react-google-maps/api";
import useApiSeguridad from "../api/seguridad";

const MapaCliente = ({ tokenGenerado }) => {
  const [viajes, setViajes] = useState([]);
  const seguridad = useApiSeguridad();
  const [hoveredViaje, setHoveredViaje] = useState(null);
  const [center, setCenter] = useState({ lat: 25.438, lng: -100.973 }); // Valor por defecto si no hay viajes

  const getIcon = (item) => {
    const path = item.esCaja
      ? "M4 0h9s4 0 4 4v14.6667s0 4 -4 4h-9s-4 0 -4 -4v-14.6667s0 -4 4 -4"
      : "M17.4225 1.49461L29.0961 26.064L17.5327 20.9555L5.80922 26.0319L17.4225 1.49461Z";
    const anchor = window.google
      ? item.esCaja
        ? new window.google.maps.Point(9, 11)
        : new window.google.maps.Point(18, 16)
      : null;
    const color = item.esCaja ? "#0081ff" : "#34c759";

    return {
      path,
      fillColor: color,
      fillOpacity: 1,
      strokeWeight: 2,
      strokeColor: "black",
      rotation: item.orientacion || 0,
      scale: 1,
      anchor,
    };
  };


  useEffect(() => {
    let isMounted = true;

    const fetchViajes = async () => {
      try {
        const res = await seguridad.getViajes(tokenGenerado);
        if (isMounted) {
          setViajes(res.posiciones);
          console.log(res.posiciones)

           const viajeConPosicion = res.posiciones.find(v => v.lat && v.lng);
          if (viajeConPosicion) {
            setCenter({ lat: viajeConPosicion.lat, lng: viajeConPosicion.lng });
          }
          
        }
      } catch (err) {
        console.error(err);
      }
    };

    fetchViajes();

    return () => {
      isMounted = false;
    };
  }, [tokenGenerado]);

  const containerStyle = { width: "100%", height: "800px" };
 

  return (
    <div>
      <LoadScript googleMapsApiKey={process.env.REACT_APP_MAP_KEY}>
        <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={6}>
          {viajes.map((item, idx) => {
            if (
                typeof item.latitud !== "number" ||
                typeof item.longitud !== "number" ||
                isNaN(item.latitud) ||
                isNaN(item.longitud)
            ) {
                console.warn("Viaje con coordenadas inválidas:", item);
                return null; // no renderizar
            }

            return (
                <Marker
                key={idx}
                position={{ lat: item.latitud, lng: item.longitud }}
                icon={getIcon(item)}
               onMouseOver={() => setHoveredViaje(item)}
              onMouseOut={() => setHoveredViaje(null)}
              
                />
            );
            })}
            {hoveredViaje && (
                <InfoWindow
                  position={{ lat: hoveredViaje.latitud, lng: hoveredViaje.longitud }}
                  options={{
                    pixelOffset: new window.google.maps.Size(0, -30),
                    disableAutoPan: true,
                  }}
                >
                  <div
                    style={{
                      fontSize: "11px",
                      fontFamily: "Arial, sans-serif",
                      backgroundColor: "#ffffff",
                      padding: "4px 6px",
                      border: "none",
                      boxShadow: "none",
                      borderRadius: "0px",
                      margin: 0,
                      lineHeight: "1.4",
                      whiteSpace: "nowrap",
                      minWidth: "180px"
                    }}
                  >
                    <div style={{ marginBottom: "2px" }}>
                      Unidad: <span style={{ fontWeight: "bold" }}>{hoveredViaje.numeroEconomico}</span>
                    </div>
                    <div style={{ marginBottom: "2px" }}>
                      Velocidad: <span style={{ fontWeight: "bold" }}>{hoveredViaje.velocidad ?? 0} km/h</span>
                    </div>
                    <div style={{ marginBottom: "2px" }}>
                      Posición:{" "}
                      <span style={{ fontWeight: "bold" }}>
                        {hoveredViaje.latitud?.toFixed(6)}, {hoveredViaje.longitud?.toFixed(6)}
                      </span>
                    </div>
                    <div>
                      Fecha:{" "}
                      <span style={{ fontWeight: "bold" }}>
                        {new Date(hoveredViaje.fecha).toLocaleString("es-MX", {
                          day: "2-digit",
                          month: "short",
                          hour: "2-digit",
                          minute: "2-digit",
                          second: "2-digit",
                          hour12: true,
                        }).replace(",", "").replace(".", "")}
                      </span>
                    </div>
                  </div>
                </InfoWindow>

            )}

        </GoogleMap>
      </LoadScript>
    </div>
  );
};

export default MapaCliente;
